import Chart from "./Chart";
import CONFIG from "../../../config";
export const filterDomain = ["X轴", "Y轴", "系列"];
export const config = {
  name: "basicRingChart",
  archive: "图表",
  domain: "饼图/环形图",
  alias: "基础环形图",
  thumb: CONFIG.ASSET_BASE_URL + "/charts/basicRingChart.png",
};
export const option = () => ({
  title: {
    text: "环形图",
  },
  series: [
    {
      name: "系列1",
      type: "pie",
      radius: ["40%", "70%"],
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: "center",
      },
      labelLine: {
        show: false,
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 24,
          fontWeight: "bold",
        },
      },
    },
  ],
});
export default (props) => {
  return <Chart defaultOption={option()} {...props} />;
};
